import { FORM_VALUES } from '../../../../constants';

export const FIELD_NAME = FORM_VALUES.description;
